import { AddressForm } from './AddressForm';

export const Address = {
  Form: AddressForm,
};

export { useAddressHandlers } from './AddressForm';
